/* eslint-disable no-mixed-operators */
/* eslint-disable brace-style */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-lonely-if */
/* eslint-disable arrow-body-style */
/* eslint-disable block-spacing */
/* eslint-disable no-trailing-spaces */
/* eslint-disable spaced-comment */
/* eslint-disable padded-blocks */
/* eslint-disable radix */
/* eslint-disable */
import Api from "../../../../api";
import FilterFields from "./filter-fields";

const FilterEditorHelperMethods = {
  /** *    Public methods    ** */
  fetchAndFormatOptions: async (practiceId) => {
    try {
      const responses = await Promise.allSettled([
        Api.dynamicGroup.private.fetchAllAppointmentStatus(practiceId),
        Api.dynamicGroup.private.fetchAllFacilities(practiceId),
        Api.dynamicGroup.private.fetchAllProviders(practiceId),
        Api.dynamicGroup.private.fetchAllAppointmentTypes(practiceId),
      ]);
      console.log("responses :>> ", responses);
      return {
        allStatus: responses[0].value ? responses[0].value.data : [],
        allFacilities: responses[1].value ? responses[1].value.data : [],
        allProviders: FilterEditorHelperMethods._formatProviders(
          responses[2].value ? responses[2].value.data : []
        ),
        allApptTypes: responses[3].value ? responses[3].value.data : [],
      };
    } catch (error) {
      console.log("error", error);
    }
  },
  fetchAndFormatFilterDataTypes: async (filterId) => {
    const { data: filterData } = await Api.dynamicGroup.private.fetchFilterData(filterId);
    const filterTypeMappedIds = {};
    filterData.forEach((filter) => {
      filterTypeMappedIds[filter.groupFilterDataType] = filter.groupFilterDataTypeID;
    });
    return filterTypeMappedIds;
  },
  preparePropsToStateFields: (propFields) => {
    const stateFields = {};
    propFields.forEach((propField) => {
      const fieldName = FilterFields.filterIdToStateMapping[propField.GroupFilterDataTypeID];
      stateFields[fieldName] = propField.GroupFilterData;
    });
    console.log(`State Fields: ${stateFields}`);
    return stateFields;
  },
  prepareStateToPropsFields: (stateFields) => {
    const propFields = [];
    Object.keys(stateFields).forEach((fieldName) => {
      if (stateFields[fieldName] && stateFields[fieldName].length) {
        const typeId = FilterFields.stateToFilterIdMapping[fieldName];
        propFields.push({
          GroupFilterDataTypeID: typeId,
          GroupFilterData: stateFields[fieldName],
        });
      }
    });
    return propFields;
  },
  validateFilterFields: ({ filtersData, filterTypeId }) => {

    const validationResult = {
      hasError: false,
      errorMessage: "",
    };

    //any filter selected but nothing filled out
    if (filterTypeId > 0 && !filtersData.length) {

      //BILLDATE - with nothing filled out
      if (filterTypeId === 2 && !filtersData.length) {
        validationResult.hasError = true;
        validationResult.errorMessage = "PastDueRange:Start and PastDueRange:End are required for this filter type.";
      }

      //AGE - with nothing filled out
      if (filterTypeId === 3 && !filtersData.length) {
        validationResult.hasError = true;
        validationResult.errorMessage = "Age:Start and Age:End are required for this filter type.";
      }
      
    } else if (filterTypeId > 0 && filtersData.length > 0) {

      //BILLDATE FilterType - with exactly two filter inputs
      if (filterTypeId === 2 && !filtersData.length !== 2) {

        //possible fileds to validate
        const startDay = filtersData.find((fdata) => fdata.GroupFilterDataTypeID === '3');
        const endDay = filtersData.find((fdata) => fdata.GroupFilterDataTypeID === '4');
        const pastDueMin = filtersData.find((fdata) => fdata.GroupFilterDataTypeID === '10');
        const pastDueMax = filtersData.find((fdata) => fdata.GroupFilterDataTypeID === '11');

        //if either one have value
        if (startDay || endDay) {

          //start value only
          if (startDay && !endDay) {
            validationResult.hasError = true;
            validationResult.errorMessage = "PastDueRange:End is required for this filter type.";
          }

          //end value only
          if (endDay && !startDay) {
            validationResult.hasError = true;
            validationResult.errorMessage = "PastDueRange:Start is required for this filter type.";
          }

        }

        //validate specifically for having a start number but no end number
        if (startDay && startDay.GroupFilterData && !endDay) {
          validationResult.hasError = true;
          validationResult.errorMessage = "PastDueRange:End is required";
        }

        //validate specifically for having an end number but no start number
        if (endDay && endDay.GroupFilterData && !startDay) {
          validationResult.hasError = true;
          validationResult.errorMessage = "PastDueRange:Start is required";
        }

        //validate start number cannot be greater than end number
        if (startDay && startDay.GroupFilterData && endDay && endDay.GroupFilterData && parseInt(startDay.GroupFilterData) > parseInt(endDay.GroupFilterData)) {
          validationResult.hasError = true;
          validationResult.errorMessage = "PastDueRange:End cannot be less than PastDueRange:Start";
        }

        //validate past due
        if (pastDueMin && pastDueMin.GroupFilterData && pastDueMax && pastDueMax.GroupFilterData && pastDueMin.GroupFilterData > pastDueMax.GroupFilterData) {
          validationResult.hasError = true;
          validationResult.errorMessage = "Past Due Min cannot be greater than Past Due Max";
        }

      //AGE FilterType
      } else if (filterTypeId === 3) { 

        //possible fields to validate
        const startDay = filtersData.find((fdata) => fdata.GroupFilterDataTypeID === '1');
        const endDay = filtersData.find((fdata) => fdata.GroupFilterDataTypeID === '2');

        //validate start day cannot be greater than end day
        if (startDay && endDay && startDay.GroupFilterData && endDay.GroupFilterData && parseInt(startDay.GroupFilterData) > parseInt(endDay.GroupFilterData)) {
          validationResult.hasError = true;
          validationResult.errorMessage = "Start age cannot be greater than end age";
        }

      }

    }
    return validationResult;
  },
  // The function will accept the filter data and make a any single value to array
  // For example, if the filter data is 1, then it should be converted to [1]
  // If the filter data is [1,2,3], then it should be returned as it is
  // If the filter data is empty, then it should be return as empty array
  formatFilterDataPayload: (filterData) => {
    return filterData.map((eachFilter) => {
      // Only change the filter data if it is not an array
      if (!Array.isArray(eachFilter.GroupFilterData)) {
        eachFilter.ListGroupFilterData = [eachFilter.GroupFilterData];
      } else {
        eachFilter.ListGroupFilterData = eachFilter.GroupFilterData;
      }
      //delete eachFilter.GroupFilterData;
      console.log(eachFilter);
      return eachFilter;
    });
  },
  // Need a function which will merge GroupDataFilters based on GroupFilterDataTypeID and make array of GroupFilterData. If there is only one filter, then it should be also converted to array with single value
  formatGroupFiltersOnLoad: groupFilters => {
    const groupFiltersMapped = {};
    const multiSelectTypeIDs = [6, 7, 8, 9];
    groupFilters.forEach((groupFilter) => {
      if (groupFiltersMapped && groupFiltersMapped.length && groupFiltersMapped[groupFilter.GroupFilterDataTypeID]) {
        groupFiltersMapped[groupFilter.GroupFilterDataTypeID].push(groupFilter.GroupFilterData);
      } else {
        // If the type id is multi select, then it should be converted to array
        if (multiSelectTypeIDs.includes(groupFilter.GroupFilterDataTypeID)) {
          groupFiltersMapped[groupFilter.GroupFilterDataTypeID] = [groupFilter.GroupFilterData];
        } else {
          groupFiltersMapped[groupFilter.GroupFilterDataTypeID] = groupFilter.GroupFilterData;
        }
      }
    });
    // Convert to array of objects
    const groupFiltersArray = [];
    Object.keys(groupFiltersMapped).forEach((key) => {
      groupFiltersArray.push({
        GroupFilterDataTypeID: key,
        GroupFilterData: groupFiltersMapped[key],
      });
    });
    // console.log('groupFilters :>> 1221111', groupFilters);
    // console.log('groupFiltersArray :>> 1221111', groupFiltersArray);
    return groupFiltersArray;
  },
  /** *    Private methods    ** */
  _formatProviders: (providers) =>
    providers.map((provider) => ({
      value: provider.ProviderID,
      label: `${provider.firstName} ${provider.lastName}`,
    })),
};

export default FilterEditorHelperMethods;
